import React, { FC, useCallback, useEffect, useState } from 'react'

import ActionButton from '../ActionButton'

import * as SC from './styled'
import { ECollapsable } from './types'

export type CollapsableProps = {
  className?: string
  header?: React.ReactNode
  backgroundColor?: string
  isCollapsable?: ECollapsable
  isOpenOnInit: boolean
  onOpenHandler?: () => void
  textToggle?: string
  rounded?: boolean
  backgroundImage?: string
}

const Collapsable: FC<CollapsableProps> = (props) => {
  const {
    className,
    children,
    header,
    backgroundColor,
    isCollapsable = ECollapsable.BOTH,
    isOpenOnInit,
    onOpenHandler,
    textToggle,
    rounded = true,
    backgroundImage,
  } = props

  const [isLocalOpen, setLocalOpen] = useState(isOpenOnInit)

  const handleOpen = useCallback(() => {
    setLocalOpen(!isLocalOpen)
    onOpenHandler && onOpenHandler()
  }, [isLocalOpen, onOpenHandler])

  useEffect(() => {
    setLocalOpen(isOpenOnInit)
  }, [isOpenOnInit])

  return (
    <SC.Container
      className={`collapsable ${className}`}
      backgroundColor={backgroundColor}
      isOpen={isLocalOpen}
      isCollapsable={isCollapsable}
      rounded={rounded}
      backgroundImage={backgroundImage}
    >
      <SC.Header isCollapsable={isCollapsable}>
        <SC.HeaderContent isCollapsable={isCollapsable}>
          {header}
        </SC.HeaderContent>
        <SC.Trigger isCollapsable={isCollapsable} isOpen={isLocalOpen}>
          <ActionButton
            text={textToggle}
            icon="chevronDown"
            variantType="button"
            variantColorScheme="black"
            variantIcon="only"
            actionProps={{
              onClick: () => handleOpen(),
              'aria-label': 'Ouvrir / Fermer',
            }}
          />
        </SC.Trigger>
      </SC.Header>
      <SC.Content
        className="collapsable-content"
        isCollapsable={isCollapsable}
        isOpen={isLocalOpen}
      >
        {children}
      </SC.Content>
    </SC.Container>
  )
}

export default Collapsable
